var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[(_vm.schools)?_c('DrivingSchoolList',{attrs:{"list":_vm.drivingSchools,"total_count":_vm.schools.total_count,"total_paid":_vm.schools.total_paid,"loading":_vm.loading},on:{"search":_vm.search,"needToUpdate":_vm.getDrivingSchoolList,"remove":_vm.removeSchool}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }